export default __webpack_public_path__ + "static/media/icon_cat_WomensBands.8e42036a.png";